<div id="cart_item_{{ entry.entryNumber }}">
    <div
        id="product_{{ entry.product.code }}"
        class="row no-gutters cart-item align-center product_code_{{ entry.product.code }}"
        [ngClass]="{ deleted: entry.quantity === 0 }">
        <div class="col-12 col-md-4 pb-2 pb-md-0 pr-md-2">
            <div class="row no-gutters">
                <div class="col-12 align-center">
                    <a
                        [id]="'cart_item_link_' + entry.entryNumber"
                        class="cx-product-image-container mr-1 cursor-pointer"
                        role="button"
                        (click)="openProductModal('cart_item_link_' + entry.entryNumber)"
                        tabindex="0">
                        <aimo-product-tag [product]="entry.product"/>
                        <cx-media
                            class="cx-product-image"
                            [container]="entry.product?.images?.PRIMARY"
                            format="cartIcon"></cx-media>
                    </a>

                    <div class="product-name-wrapper">
                        <button
                            [id]="'cart_item_name_' + entry.entryNumber"
                            class="btn-link text-left text-bold"
                            [attr.aria-label]="
                                'aimo.product.openModal.arialLabel' | cxTranslate: { productName: entry.product.name }
                            "
                            (click)="openProductModal('cart_item_name_' + entry.entryNumber)"
                            tabindex="0">
                            {{ entry.product.name }}
                        </button>

                        <div class="product-code">
                            <aimo-product-code [product]="entry.product"></aimo-product-code>
                            <div class="d-inline aimo-popover ml-3">
                                <aimo-last-purchased [product]="entry.product"></aimo-last-purchased>
                            </div>
                        </div>
                    </div>

                    <div class="btn btn-icon btn-icon-transparent d-inline-block d-md-none ml-1">
                        @if (entry.deletable) {
                            @if (!showTrashSpinner) {
                                <i class="aimo-icon icon-trash icon-inline" (click)="deleteEntry(entry)"></i>
                            }
                            @if (showTrashSpinner) {
                                <div #spinnerDiv class="spinner icon-inline">
                                    <aimo-spinner
                                        class="spinner-xsm"
                                        [isModal]="false">
                                    </aimo-spinner>
                                </div>
                            }
                        }
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-3 col-12">
            <div class="row no-gutters align-center">
                <div class="d-md-none col-5">
                    {{ 'aimo.cart.item.basePrice' | cxTranslate }}
                    {{ 'aimo.cart.item.notax' | cxTranslate }}
                </div>
                <div class="col-7 col-md-6 cart-item-data cart-item-data-right">
                    <div>
                        @if (entry.product.myAssortment) {
                            @if (myAssortmentLabelSuffix$ | async; as myAssortmentLabelSuffix) {
                                <i
                                    placement="top"
                                    container="body"
                                    triggers="mouseenter:mouseleave"
                                    [ngbPopover]="
                                        'aimo.product.myAssortment' + myAssortmentLabelSuffix.suffix | cxTranslate
                                    "
                                    class="aimo-icon icon-inline icon-sm icon-house-line-bold"
                                    [ngClass]="entry.strikeThroughPrice ? 'icon-red' : 'icon-petrol-blue'"></i>
                            }
                        }
                        <span
                            class="text-bold d-inline-block mr-1"
                            [ngClass]="
                                entry.strikeThroughPrice ? 'text-red' : entry.product.myAssortment ? 'text-primary' : ''
                            "
                        >{{ entry.basePrice?.formattedValue }}
                        </span>
                        <span class="d-inline-block mr-1"> / {{ entry.unit.name }} </span>
                    </div>
                    @if (entry.strikeThroughPrice) {
                        <div class="text-strike">
                            <span class="d-inline-block mr-1"> {{ entry.strikeThroughPrice?.formattedValue }} </span>
                            <span class="d-inline-block mr-1"> / {{ entry.unit.name }} </span>
                        </div>
                    }
                </div>
                <div class="col-7 col-md-6 cart-item-data cart-item-data-right d-none d-md-block">
                    @if (entry.comparisonPrice) {
                        <div>
                            <span class="d-inline-block mr-1"> {{ entry.comparisonPrice?.formattedValue }} </span>
                            <span class="d-inline-block mr-1"> / {{ entry.comparisonUnit?.name }} </span>
                        </div>
                    }
                    @if (entry.strikeThroughComparisonPrice) {
                        <div class="text-strike">
                            <span class="d-inline-block mr-1">
                                {{ entry.strikeThroughComparisonPrice?.formattedValue }}
                            </span>
                            <span class="d-inline-block mr-1"> / {{ entry.comparisonUnit?.name }} </span>
                        </div>
                    }
                </div>
            </div>
        </div>

        <div class="d-md-none col-5">
            {{ 'aimo.cart.item.quantity' | cxTranslate }}
        </div>

        <div class="col-md-2 col-7 cart-item-data cart-item-data-right" [formGroup]="addToCartForm">
            <div class="align-center">
                <span class="d-inline-block d-md-none mr-2 ml-auto">
                    @if (entry.sizeInBaseUnits !== 1 && entry.sizeInBaseUnits !== 0) {
                        {{ entry.sizeInBaseUnits }} {{ entry.product.baseUnit?.name }}
                    }
                </span>
                @if (entry.editable) {
                    <aimo-item-counter
                        class="cart-item-counter noPrint"
                        [autoAddToCart]="true"
                        [min]="0"
                        [id]="'quantity_' + entry.entryNumber"
                        [step]="entry.product.allowedLotSize"
                        [control]="addToCartForm.get('quantity')"
                        [unitName]="entry.unit.name"
                        [cartCounter]="true"
                        [product]="entry.product"
                        [gtmProductAttributes]="gtmProductAttributes"
                        (afterChange)="changeQuantity()"></aimo-item-counter>
                }
                @if (!entry.editable) {
                    <span class="noPrint">{{ entry.quantity }} {{ entry.unit.name }}</span>
                }
                <div class="pt-2 onlyPrint">{{ entry.quantity }} {{ entry.unit.name }}</div>
            </div>
        </div>

        <div class="col-md-1 d-none d-md-flex">
            @if (entry.sizeInBaseUnits !== 1 && entry.sizeInBaseUnits !== 0) {
                <span>{{ entry.sizeInBaseUnits }} {{ entry.product.baseUnit?.name }}</span>
            }
        </div>

        <div class="d-md-none col-6">
            {{ 'aimo.cart.item.total' | cxTranslate }}
            {{ 'aimo.cart.item.notax' | cxTranslate }}
        </div>

        <div class="col-md-2 col-6 d-md-flex cart-item-data cart-item-data-right align-center">
            <div class="mr-auto">
                <div class="text-bold">
                    <span class="d-inline-block mr-1">{{ entry.totalPrice?.formattedValue }}</span>
                </div>
                @if (!cart.paymentMode.credit || !alreadyOrdered) {
                    <div class="d-none d-md-block text-lowercase">
                        <span class="d-inline-block mr-1">{{ entry.totalPriceWithTax?.formattedValue }}</span>
                        <span class="d-inline-block">
                            ({{ 'aimo.cart.totals.vat' | cxTranslate: {tax: entry.tax?.rate} }})
                        </span>
                    </div>
                }
                <aimo-cart-item-deposits
                    [alreadyOrdered]="alreadyOrdered"
                    [paymentMode]="cart.paymentMode"
                    [aimoEntry]="entry"></aimo-cart-item-deposits>
            </div>

            @if (cart?.user.tukkumyyja && !isPikatukku() && entry.deletable) {
                <button
                    class="btn btn-xs btn-icon btn-icon-transparent d-none d-md-block noPrint"
                    [attr.aria-label]="'aimo.arialLabel.cart.messages' | cxTranslate"
                    (click)="openEntryMessagesModal(entry)">
                    <i class="aimo-icon icon-chat-circle-text icon-inline icon-petrol-blue noPrint"></i>
                    @if (numberOfMessages > 0) {
                        <span class="circle circle-sm bg-petrol quantity text-white text-xxsm noPrint">{{
                                numberOfMessages
                            }}</span>
                    }
                </button>
            }

            @if (entry.deletable) {
                @if (!showTrashSpinner) {
                    <button
                        class="btn btn-xs btn-icon btn-icon-transparent d-none d-md-block noPrint"
                        [attr.aria-label]="'aimo.arialLabel.cart.remove' | cxTranslate"
                        (click)="deleteEntry(entry)">
                        <i class="aimo-icon icon-trash icon-inline icon-petrol-blue noPrint"></i>
                    </button>
                }
                @if (showTrashSpinner) {
                    <div #spinnerDiv class="spinner d-none d-md-block ">
                        <aimo-spinner
                            class="spinner-xsm"
                            [isModal]="false">
                        </aimo-spinner>
                    </div>
                }
            }

            @if (!entry.deletable) {
                <div class="btn btn-xs btn-icon btn-icon-transparent disabled d-none d-md-block noPrint">
                    <i
                        placement="top"
                        container="body"
                        triggers="mouseenter:mouseleave"
                        [ngbPopover]="
                            (entry.baseOrder ? 'aimo.baseorder.notModifiable' : 'aimo.cart.item.locked') | cxTranslate
                        "
                        class="aimo-icon icon-lock-key icon-inline icon-mid-grey"></i>
                </div>
            }
        </div>

        <div class="d-md-none col-6">
            {{ 'aimo.cart.item.totalWithTax' | cxTranslate: {tax: entry.tax?.rate} }}
        </div>

        @if (!cart.paymentMode.credit) {
            <div class="d-md-none col-6 cart-item-data cart-item-data-right">
                {{ entry.totalPriceWithTax?.formattedValue }}
            </div>
        }

        @if (entry.closingTime && entry.external && entry.editable) {
            <div class="open-until">
                {{
                    'aimo.cart.item.openUntil'
                        | cxTranslate
                        : {
                            date: entry.closingTime | cxDate: ('aimo.dateFormat' | cxTranslate),
                            time: entry.closingTime | cxDate: ('aimo.timeFormat' | cxTranslate),
                        }
                }}
            </div>
        }

        <aimo-cart-item-errors
            [aimoEntry]="entry"
            [showCloseIcon]="true"
            [gtmProductAttributes]="gtmProductAttributes"
            class="col-12">
        </aimo-cart-item-errors>
    </div>
</div>
